export const profileData = `I'm a United States-based aspiring full-stack developer, driven by a deep passion for coding and a strong aptitude for problem-solving. My goal is to leverage my skills to build impactful software. Beyond the keyboard, you can often find me engaging with mathematical concepts, immersed in gaming, or on the volleyball court.`;

export const companiesData = [
  { type: "brand", name: "Mutual Of Omaha" },
  {
    left: true,
    year: "March 2025 - Present",
    project: "Annuity Sales",
    role: "Technical Lead",
    description:
      "In the Annuity Sales ecosystem, legacy backend and frontend components are being transitioned to the modern microservices architecture to enhance system resilience, reliability, and efficiency—ultimately delivering a superior customer experience",
    techTitle: "Technologies",
    technologies: [
      "Java",
      "Groovy",
      "Sprint Boot",
      "React JS",
      "Redux",
      "MUI",
      "Formik",
      "Yup",
      "SQL",
      "MongoDB",
      "Junit",
      "Mockito",
      "Jest",
      "Jenkins",
      "GitHub Actions",
      "Docker",
      "Kubernetes",
      "AWS",
    ],
    companyUrl: "https://www.mutualofomaha.com",
  },
  { type: "brand", name: "Wells Fargo" },
  {
    left: false,
    year: "March 2022 - March 2025",
    project: "Collection & Recovery",
    role: "Senior Software Engineer",
    description:
      "The Collection and Recovery project consists of several services to support the bank's collection and recovery agents. Its goals are to increase productivity, lower costs, assist customers, and automate manual procedures.",
    techTitle: "Technologies",
    technologies: [
      "Java",
      "Sprint Boot",
      "React JS",
      "Redux",
      "MUI",
      "Formik",
      "Yup",
      "MongoDB",
      "Playwright",
      "Junit",
      "Mockito",
      "Cucumber",
      "Jenkins",
      "Harness",
      "UCD",
      "Splunk",
      "Checkmarx",
      "SonarQube",
      "Black Duck",
      "ThreadFix",
    ],
  },
  { type: "brand", name: "Nineleaps" },
  {
    left: true,
    year: "May 2020 - March 2022",
    project: "Tim Hortons",
    role: "Technical Lead",
    description:
      "Tim Hortons is the complete solution for a store. It is implemented in such a way as to manage all the stores' operations and the details of its employees. Below are a few modules developed so far. " +
      "Restaurant Excellence Visit: It is used to do store audits, and based on that, the store gets a rating. " +
      "Identity Access Management: its users' specific service to manage the user details. Along with authentication and authorization using Spring Security. " +
      "Store: Store service is used to manage the store, such as creating, reading, updating, and deleting. " +
      "Production Sheet: This service is dedicated to the store's daily production sheet to manage the item inventory. " +
      "LMS: Learning & Management System is an online learning platform for the employees of Tim Hortons. They can take training, learn, and take some quizzes and assessments based on that, and they get certified in that module.",
    techTitle: "Technologies",
    technologies: [
      "Java",
      "Sprint Boot",
      "Hibernate",
      "JPA",
      "PostgreSQL",
      "Junit",
      "Mockito",
      "Jenkins",
      "Docker",
      "Kubernetes",
      "AWS",
    ],
  },
  { type: "brand", name: "DXC Technology" },
  {
    left: false,
    year: "May 2017 - May 2020",
    project: "Integral Admin",
    role: "Senior Software Engineer",
    description:
      "Integral Admin is a one-stop insurance solution for every kind of insurance system, such as life, group, and PNC. For multiple projects, Integral Admin is working as a back-end service. As a back-end developer, I get the chance to enhance and develop modules for LIFE insurance in Java 8, Spring Boot, Hibernate, and MSSQL. To create a life insurance policy for a group, build a batch processing unit.",
    techTitle: "Technologies",
    technologies: [
      "Java",
      "Sprint Boot",
      "Hibernate",
      "MSSQL",
      "Junit",
      "Mockito",
      "Jenkins",
      "Git",
      "SonarQube",
    ],
  },
  { type: "brand", name: "Times Internet" },
  {
    left: false,
    year: "Feb 2016 - May 2017",
    project: "Timesjobs.com",
    role: "Software Engineer",
    description:
      "As a back-end developer, I contributed to a job search engine, building and maintaining the core functionalities for both the employer and job seeker sides. I was responsible for the systems that allowed companies to post and manage job listings, as well as the algorithms and databases that helped candidates find and apply for those positions",
    techTitle: "Technologies",
    technologies: [
      "Java",
      "JSP",
      "Sprint MVC",
      "Hibernate",
      "MySQL",
      "Junit",
      "Gradle",
      "Git",
      "Apache Tomcat",
      "Jasper Report",
    ],
  },
  { type: "brand", name: "Enthouns Technology" },
  {
    left: false,
    year: "Dec 2013 - Feb 2016",
    project: "Data Export Import Utilities",
    role: "Assistance Software Engineer",
    description:
      "The DEIU application is a telecom domain application that is used to store customer-related documents such as ID proof, address proof, etc. So, it’s a kind of customer document repository.",
    techTitle: "Technologies",
    technologies: [
      "Java",
      "Sprint MVC",
      "Hibernate",
      "MSSQL",
      "Junit",
      "Apache Ant",
      "TortoiseSVN",
      "Apache Tomcat",
      "Documentum",
    ],
  },
];

//Navigation data for Navbar component
export const pages = [
  { label: "Technical Skills", route: "/skills" },
  // { label: "Projects", route: "/projects" },
  { label: "Experience", route: "/experience" },
  { label: "Hire Me", route: "/hire" },
];
